import { Flex, Image, Spinner } from '@chakra-ui/react';
import { apiSalesWeb } from '@shared/config';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { createRequestId } from '../services/createRequestId';

export const CheckoutLayout = () => {
  const [haveRequestId, setHaveRequestId] = useState(false);

  const getRequestId = async () => {
    const requestIdSession = sessionStorage.getItem('requestId');
    if (!requestIdSession) {
      const { data } = await createRequestId();

      sessionStorage.setItem('requestId', data.requestId);

      apiSalesWeb.defaults.headers['request-id'] = data.requestId;
      setHaveRequestId(true);

      return;
    }

    setHaveRequestId(true);
    apiSalesWeb.defaults.headers['request-id'] = requestIdSession;
    return;
  };

  useEffect(() => {
    getRequestId();
  }, []);

  return (
    <Flex maxH="100dvh" overflow="auto">
      <Flex
        width={100}
        bgImage="/images/sidebar.png"
        justifyContent="center"
        alignItems="start"
        p={4}
        display={{ base: 'none', lg: 'flex' }}
      >
        <Image src="/images/Icon.png" alt="logo" />
      </Flex>
      {haveRequestId ? (
        <Outlet />
      ) : (
        <Flex justifyContent="center" alignItems="center" w="full" h="100dvh">
          <Spinner size="xl" />
        </Flex>
      )}
    </Flex>
  );
};
